function MapPin({ className = "" }) {
  return (
    <svg
      className={`inline-block w-3.5 h-3.5 -mt-0.5 mr-0.5 text-brown/80 ${className}`}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
    </svg>
  );
}

function LocationPart({ seg, pin }) {
  if (!seg.location) return null;
  const { url, label } = seg.location;
  const labelTruncate =
    "min-w-0 truncate max-w-[min(11rem,42vw)] sm:max-w-[14rem] md:max-w-[min(16rem,36vw)] lg:max-w-none";
  if (url) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        title={label}
        className="group inline-flex flex-nowrap items-baseline shrink min-w-0 cursor-pointer no-underline"
      >
        <span className="text-gray-500 shrink-0"></span>
        {pin ? <MapPin /> : null}
        <span
          className={`font-medium text-brown ${labelTruncate} group-hover:underline`}
        >
          {label}
        </span>
        <span className="text-gray-500 shrink-0"></span>
      </a>
    );
  }
  return (
    <span className="inline-flex flex-nowrap items-baseline min-w-0" title={label}>
      <span className="text-gray-500 shrink-0">(</span>
      {pin ? <MapPin /> : null}
      <span className={`font-medium text-gray-800 ${labelTruncate}`}>
        {label}
      </span>
      <span className="text-gray-500 shrink-0">)</span>
    </span>
  );
}

function DurationBadge({ minutes, details, language }) {
  if (minutes !== 60 && minutes !== 90) return null;
  const label =
    language === "russian"
      ? `${minutes} ${details.min}`
      : `${minutes} min`;
  return (
    <span className="inline-block align-middle ml-0.5 shrink-0 text-[9px] font-semibold tabular-nums uppercase tracking-wide px-1 py-px rounded bg-cream text-clay border border-sand-dark/35">
      {label}
    </span>
  );
}

export default function ScheduleSummaryLine({
  segments,
  details,
  language,
}) {
  const hasData = segments.length > 0;

  return (
    <div className="w-full max-w-3xl mx-auto mb-2 px-4 sm:px-5 md:px-3">
      <p className="text-center text-xs sm:text-[13px] md:text-sm text-gray-800 leading-tight">
        {!hasData ? (
          <span className="text-gray-500">{details.comingSoon}</span>
        ) : (
          segments.map((seg, i) => {
            return (
              <span
                key={seg.id}
                className={
                  "flex flex-row flex-nowrap items-baseline gap-x-1 w-full min-w-0 " +
                  "justify-center " +
                  "overflow-x-auto overscroll-x-contain [scrollbar-width:thin] md:overflow-visible " +
                  "pb-1 mb-1 border-b border-gray-200/90 last:mb-0 last:pb-0 last:border-b-0 " +
                  "md:inline-flex md:w-auto md:max-w-none md:mx-auto md:pb-0 md:mb-0 md:border-b-0"
                }
              >
                {i > 0 ? (
                  <span
                    className="hidden md:inline shrink-0 mx-2 text-gray-300"
                    aria-hidden
                  >
                    ·
                  </span>
                ) : null}
                <span className="text-gray-700 whitespace-nowrap shrink-0">
                  {[seg.daysLine, seg.time].filter(Boolean).join(" ")}
                </span>
                <DurationBadge
                  minutes={seg.durationMinutes}
                  details={details}
                  language={language}
                />
                <LocationPart seg={seg} pin />
              </span>
            );
          })
        )}
      </p>
    </div>
  );
}
